import * as constants from './profile-edit-modal-constants';

export function editFieldForModal(update) {
  return {
    type: constants.EDIT_FIELD_FOR_MODAL,
    payload: update,
  };
}

export function startEdit(options) {
  return {
    type: constants.START_EDIT,
    payload: options,
  };
}

export function startInlineEdit(options) {
  return {
    type: constants.START_INLINE_EDIT,
    payload: options,
  }
}

export function clearEditModalState() {
  return { type: constants.CLEAR_EDIT_MODAL_STATE };
}



// WEBPACK FOOTER //
// ./src/app/stores/profile-edit-modal/profile-edit-modal-actions.js